import { FormFieldWrapper, WrappedInputProps } from '@/common/components/Form/FormFieldWrapper.tsx'
import React, { HTMLInputTypeAttribute } from 'react'
import { useController, useWatch } from 'react-hook-form'
import { cn } from '@/utils/style.ts'
import { useFormSection } from '@/common/components/Form/useFormSection.tsx'
import { Input } from 'antd'

type FormInputProps = {
  placeholder?: string
  disabled?: boolean
  inputType?:  HTMLInputTypeAttribute
} & WrappedInputProps

export const FormInput: React.FC<FormInputProps> = ({
  name,
  label,
  description,
  placeholder,
  className,
  wrapperClassName,
  inputType = 'text',
  disabled,
}) => {
  const { fieldName } = useFormSection(name)
  const { field } = useController({ name: fieldName })
  const value = useWatch({ name: fieldName }) ?? ''

  return (
    <FormFieldWrapper
      className={wrapperClassName}
      name={name}
      label={label}
      disabled={disabled}
      description={description}
    >
      <Input
        className={cn('w-full py-1 px-3 h-8', className)}
        placeholder={placeholder} {...field}
        value={value}
        disabled={disabled}
        type={inputType}
      />
    </FormFieldWrapper>
  )
}